module.exports = __webpack_public_path__ + "static/img/autumn_pingguoPic.35fd77f6.png";